import { render, staticRenderFns } from "./googleCode.vue?vue&type=template&id=510db2e2&scoped=true&"
import script from "./googleCode.vue?vue&type=script&lang=js&"
export * from "./googleCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510db2e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2024/xinyushan/sdYuShan/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('510db2e2')) {
      api.createRecord('510db2e2', component.options)
    } else {
      api.reload('510db2e2', component.options)
    }
    module.hot.accept("./googleCode.vue?vue&type=template&id=510db2e2&scoped=true&", function () {
      api.rerender('510db2e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/login/googleCode.vue"
export default component.exports